import React from 'react';
import OtpInput from 'react-otp-input';
import { Button, TextField, Stack, Box, Typography } from "@mui/material";

const OtpInputPage = ({ onAuthenticateLogin, otpResponse, loginDetails, resendOtp, otpResent, setOtpResent }) => {

    const [{ otp, numInputs, separator, minLength, maxLength, placeholder, inputType }, setConfig] = React.useState({
        otp: '',
        numInputs: 6,
        separator: '-',
        minLength: 0,
        maxLength: 40,
        placeholder: '',
        inputType: 'number',
    });

    const handleOTPChange = (otp) => {
        setConfig((prevConfig) => ({ ...prevConfig, otp }));
        if (otp.length === numInputs) {
            onAuthenticateLogin(loginDetails.id, otp);
        }
    };

    const clearOtp = () => {
        setConfig((prevConfig) => ({ ...prevConfig, otp: '' }));
    };
    const _resendOTP = () => {
        resendOtp();
        setOtpResent(true);
        clearOtp();
    };
    const handleSubmit = (event) => {
        event.preventDefault();
    };


    return (
        <div>
            <div style={{ display: 'flex', justifyContent: 'center', margin: '100px' }}>
                <form style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', padding: "16px 0px", position: 'relative' }} onSubmit={handleSubmit}>
                    <Typography style={{ textAlign: 'center', marginTop: '-6px', marginBottom: '3px' }} variant='h4'>Enter Verification Code</Typography>
                    <div>
                        <OtpInput
                            inputStyle="inputStyle"
                            numInputs={numInputs}
                            onChange={handleOTPChange}
                            renderSeparator={<span>{separator}</span>}
                            value={otp}
                            placeholder={placeholder}
                            inputType={inputType}
                            renderInput={(props) => <input {...props} />}
                            shouldAutoFocus
                        />
                    </div>
                    <div style={{ position: 'absolute', top: 90, left: 16 }}>
                        {otpResponse === 3 && !otpResent &&
                            <div>
                                <label style={{ color: 'red' }}>Verification Code expired.</label>
                            </div>
                        }
                        {otpResponse === 2 && !otpResent &&
                            <div>
                                <label style={{ color: 'red' }}>Invalid Verification Code.</label>
                            </div>
                        }
                    </div>

                    <Stack justifyContent={'center'} sx={{ marginTop: '32px' }} direction={'row'} spacing={2}>
                        <Button sx={{ background: 'grey', textTransform: 'none' }} variant="contained" type="button" disabled={otp.trim() === ''} onClick={clearOtp}>
                            Clear
                        </Button>
                        <Button variant="contained" sx={{ textTransform: 'none' }} onClick={() => { _resendOTP() }} >
                            Resend Verification Code
                        </Button>
                    </Stack>
                </form>
            </div>
        </div>
    );
}

export default OtpInputPage;